import React, { useState } from "react";
import { object } from "prop-types";
import { SocialShare } from "@quintype/components";
import StickySocialShareTemplate from "../../molecules/sticky-social-share";

import "./social-share.m.css";
import useUrl from "../../../hook/useUrl";
import useSocialShareLinks from "../../../hook/useSocialShareLinks";

const SocialShareBottom = ({ story }) => {
  const [_,currentUrlSlug]=useUrl();
  let domainSlug=""
  if(currentUrlSlug==="vaasa-lehti"){
    domainSlug="vaasa"
  }else{
    domainSlug="ilkka-pohjalainen"
  }
  const socialShareLinks= useSocialShareLinks(story,domainSlug);
  const metakeywords = story["seo"]["meta-keywords"];
  const hashtags = metakeywords ? metakeywords.map(item => {
    return item.replace(/ /g, "");
  }) : "";

  return (
    <div styleName="wrapper" className="social-share-wapper">
      <SocialShare template={StickySocialShareTemplate} title={story.headline} fullUrl={socialShareLinks}
      hashtags={story["seo"]["meta-keywords"] ? hashtags.join(",") : ""} story={story}/>
    </div>
  );
};

SocialShareBottom.propTypes = {
  story: object
};

export default SocialShareBottom;
